import {
  Box,
  Grid,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import { addInfusionDate } from "../../../slices/manufacturer";
import FormikControl from "../FormikControl";
import { selectCurrentCycle } from "../../../slices/common";
import moment from 'moment'
import { useState } from "react";

const initialValues = {
  infusion_date: "",
};

const InfusionForm = (
  formProps
) => {
    const dispatch = useDispatch();
    const currentCycle = useSelector(selectCurrentCycle)
  const [isLoading, setIsLoading] = useState(false);
    const validationSchema = Yup.object().shape({
    infusion_date: Yup.string().required("Please select infusion date")
    });
    const is_cr = currentCycle?.data?.find((it) => it?.slug == 'infusion')?.change_requests?.length > 0 ? true : false;

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      // Prepare API payload with the selected restart option
      const payload = {
        subject_id: formProps?.subject_id,
         is_cr: is_cr,
        feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
        product_manufacturing_stages_id: currentCycle?.product_manufacturing_id,        
        qr_code_generated_id: currentCycle?.qr_code_generation_id,
        infusion_date: moment(values?.infusion_date, "DD/MM/YYYY").format("YYYY-MM-DDTHH:mm:ss")
      };
        const res = await dispatch(addInfusionDate(payload)).unwrap();
      if (res?.status === 200) {
        formProps.handleFormSubmit();
      }
    } catch (err) {
      console.error("Error restarting manufacturing:", err);
    }
     finally {
      setIsLoading(false); 
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });

  const formOptions = [
        {
          label: 'Add Date',
          type: 'date',
          name: 'infusion_date',
          placeholder: 'Enter Date',
         // min: new Date(),
          required: true,
        }
  ];
  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} className="mb-3">
          {formOptions.map((props, key) => (
            <Grid key={key} item xs={12}>
              <FormikControl formik={formik} {...props} />
            </Grid>
          ))}
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <LoadingButton
              fullWidth
              type="submit"
              variant="contained"
              loading={isLoading}
              disabled={isLoading}  
              sx={{ backgroundColor: "#3571FF", '&.Mui-disabled': {
                  pointerEvents: 'auto',     
                  cursor: 'not-allowed',       
                } }}
            >
             Submit
            </LoadingButton>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default InfusionForm;
